(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  const initializeProductSection = (section) => {
    if (!section || section.dataset.productInitialized === 'true') return;

    const variantData = section.querySelector('[data-product-variant-data]');
    const hiddenVariant = section.querySelector('[data-product-variant-id]');
    const priceWrapper = section.querySelector('[data-product-price-wrapper]');
    const price = section.querySelector('[data-product-price]');
    const comparePrice = section.querySelector('[data-product-compare-price]');
    const compareValue = section.querySelector('[data-product-compare-value]');
    const unitPrice = section.querySelector('[data-product-unit-price]');
    const unitPriceValue = section.querySelector('[data-product-unit-price-value]');
    const availability = section.querySelector('[data-product-availability]');
    const quantity = section.querySelector('[data-product-quantity]');
    const submit = section.querySelector('[data-product-submit]');
    const formErrors = section.querySelector('[data-product-errors]');
    const optionGroups = Array.from(section.querySelectorAll('[data-product-option]'));
    const optionInputs = Array.from(section.querySelectorAll('[data-product-option-value]'));
    const mediaTrack = section.querySelector('[data-media-track]');
    const mediaSlides = Array.from(section.querySelectorAll('[data-media-id]'));
    const mediaThumbnails = Array.from(section.querySelectorAll('[data-media-thumbnail]'));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!variantData || !hiddenVariant || !priceWrapper || !price || !availability || !quantity || !submit) return;

    hiddenVariant.disabled = false;
    formErrors?.focus();

    const variants = Array.from(variantData.options);

    const selectedOptions = () => optionGroups.map((group) => group.querySelector(':checked')?.value ?? '');

    const findVariant = () => {
      const selections = selectedOptions();
      if (selections.length === 0) {
        return variants.find((variant) => variant.value === hiddenVariant.value) ?? variants[0];
      }

      return variants.find((variant) =>
        selections.every((selection, index) => variant.dataset[`option${index + 1}`] === selection),
      );
    };

    const setActiveMedia = (mediaId) => {
      mediaThumbnails.forEach((thumbnail) => {
        thumbnail.setAttribute('aria-current', String(thumbnail.dataset.mediaThumbnail === String(mediaId)));
      });
    };

    const activateMedia = (mediaId, behavior = 'smooth') => {
      if (!mediaId || !mediaTrack) return;
      const slide = mediaSlides.find((item) => item.dataset.mediaId === String(mediaId));
      if (!slide) return;
      slide.scrollIntoView({ behavior: reduceMotion ? 'auto' : behavior, block: 'nearest', inline: 'start' });
      setActiveMedia(mediaId);
    };

    const updateOptionAvailability = () => {
      const selections = selectedOptions();
      optionInputs.forEach((input) => {
        const group = input.closest('[data-product-option]');
        const optionIndex = Number(group?.dataset.optionPosition ?? 1) - 1;
        const candidate = selections.slice();
        candidate[optionIndex] = input.value;
        const isAvailable = variants.some(
          (variant) =>
            variant.dataset.available === 'true' &&
            candidate.every((selection, index) => variant.dataset[`option${index + 1}`] === selection),
        );
        const label = input.closest('.product-main__option-label');
        const unavailableText = label?.querySelector('[data-option-unavailable]');
        label?.classList.toggle('is-unavailable', !isAvailable);
        if (unavailableText) unavailableText.hidden = isAvailable;
      });
    };

    const updateVariant = (variant, updateUrl, moveMedia) => {
      const exists = Boolean(variant);
      const isAvailable = variant?.dataset.available === 'true';
      hiddenVariant.value = variant?.value ?? '';
      priceWrapper.hidden = !exists;

      if (exists) {
        price.textContent = variant.dataset.price;
        if (comparePrice && compareValue) {
          compareValue.textContent = variant.dataset.comparePrice;
          comparePrice.hidden = !variant.dataset.comparePrice;
        }
        if (unitPrice && unitPriceValue) {
          unitPriceValue.textContent = variant.dataset.unitPrice;
          unitPrice.hidden = !variant.dataset.unitPrice;
        }

        const minimum = variant.dataset.quantityMin || '1';
        const increment = variant.dataset.quantityIncrement || '1';
        const maximum = variant.dataset.quantityMax;
        quantity.min = minimum;
        quantity.step = increment;
        quantity.value = minimum;
        if (maximum) {
          quantity.max = maximum;
        } else {
          quantity.removeAttribute('max');
        }
      } else {
        if (comparePrice) comparePrice.hidden = true;
        if (unitPrice) unitPrice.hidden = true;
      }

      quantity.disabled = !isAvailable;
      submit.disabled = !isAvailable;
      availability.textContent = exists
        ? isAvailable
          ? section.dataset.availableText
          : section.dataset.soldOutText
        : section.dataset.unavailableText;
      submit.textContent = exists
        ? isAvailable
          ? section.dataset.addText
          : section.dataset.soldOutText
        : section.dataset.unavailableText;

      if (updateUrl && window.history?.replaceState) {
        const url = new URL(window.location.href);
        if (exists) {
          url.searchParams.set('variant', variant.value);
        } else {
          url.searchParams.delete('variant');
        }
        window.history.replaceState({}, '', url.toString());
      }

      if (moveMedia && variant?.dataset.featuredMediaId) {
        activateMedia(variant.dataset.featuredMediaId);
      }
    };

    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        updateVariant(findVariant(), true, true);
        updateOptionAvailability();
      });
    });

    mediaThumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => activateMedia(thumbnail.dataset.mediaThumbnail));
      thumbnail.addEventListener('keydown', (event) => {
        let targetIndex = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') targetIndex = index + 1;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') targetIndex = index - 1;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = mediaThumbnails.length - 1;
        if (targetIndex === null) return;
        event.preventDefault();
        const target = mediaThumbnails[(targetIndex + mediaThumbnails.length) % mediaThumbnails.length];
        target.focus();
        target.click();
      });
    });

    if (mediaTrack && mediaSlides.length > 1 && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          const active = entries.find((entry) => entry.isIntersecting);
          if (active) setActiveMedia(active.target.dataset.mediaId);
        },
        { root: mediaTrack, threshold: 0.65 },
      );
      mediaSlides.forEach((slide) => observer.observe(slide));
    }

    const initialVariant = findVariant();
    updateVariant(initialVariant, false, true);
    updateOptionAvailability();
    section.dataset.productInitialized = 'true';
  };

  document.querySelectorAll('[data-product-section]').forEach(initializeProductSection);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches?.('[data-product-section]')
      ? event.target
      : event.target.querySelector('[data-product-section]');
    initializeProductSection(section);
  });

  } catch(e) { console.error(e); }
})();
})();
